export default "__VITE_ASSET__BGn9LEUw__"